import { produce } from "@/utils/immer.ts";
import type { AnyRouter, HistoryState, RouterHistory } from "@tanstack/react-router";

export function replaceHistoryState(router: AnyRouter, fn: (state: HistoryState) => void) {
    const currentState = router.state.location.state;
    (router.history as RouterHistory).replace(router.state.location.pathname, produce(currentState, fn));
}
